import React from 'react'
import ResultadosCard from '@/components/ResultadosCard'
import NuevosCamposCard from '@/components/NuevosCamposCard'
import iconAsterisk from '@/images/icon-asterisk.svg'
import iconGlasses from '@/images/icon-glasses.svg'

const BotonesHome = () => {
  return (
    <div className="grid sm:grid-cols-2">
      <ResultadosCard
        className="bg-purpura-full sm:px-10 sm:py-20 py-4 px-4"
        to="/rankings-generales/general/">
        <span className="text-6xl">
          <img src={iconAsterisk} />
        </span>
        <h3 className="text-6xl font-light leading-none">Rankings Generales</h3>
      </ResultadosCard>
      <ResultadosCard
        className="bg-purpura-claro sm:px-10 sm:py-20 py-4 px-4"
        to="/rankings-por-carrera/arquitectura/">
        <span className="text-6xl">
          <img src={iconGlasses} />
        </span>
        <h3 className="text-6xl font-light leading-none">
          Rankings por carrera
        </h3>
      </ResultadosCard>
      {/* <NuevosCamposCard className="col-span-2 bg-turquesa sm:px-10 sm:py-20 py-4 px-4 " /> */}
    </div>
  )
}

export default BotonesHome
